import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { SkeletonRegion } from 'shared/components/ui/Skeleton';
import { EASE_OUT } from 'shared/components/motion/tokens';

interface LoadingStateProps {
  label?: string;
}

export function LoadingState({ label = 'Carregando...' }: LoadingStateProps) {
  return <p className="px-4 py-12 text-center text-sm text-ink-secondary">{label}</p>;
}

interface ErrorStateProps {
  message: string;
}

export function ErrorState({ message }: ErrorStateProps) {
  return <p className="px-4 py-12 text-center text-sm text-danger">{message}</p>;
}

interface AsyncSectionProps {
  isLoading: boolean;
  error: string | null;
  loadingLabel?: string;
  /** Esqueleto com o formato do conteúdo; sem ele, cai no texto de carregamento. */
  skeleton?: ReactNode;
  children: ReactNode;
}

// Substitui o ternário isLoading/error repetido em toda página que consome useAsyncData.
export function AsyncSection({ isLoading, error, loadingLabel, skeleton, children }: AsyncSectionProps) {
  if (isLoading) {
    return skeleton ? <SkeletonRegion label={loadingLabel}>{skeleton}</SkeletonRegion> : <LoadingState label={loadingLabel} />;
  }
  if (error) return <ErrorState message={error} />;

  // Só opacidade (sem transform): não cria contexto de posicionamento para elementos fixed.
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3, ease: EASE_OUT }}>
      {children}
    </motion.div>
  );
}
